import React, { FC, HTMLProps } from "react";
import { useTranslation } from "react-i18next";
import stl from "./index.module.scss";
import BookingDetails, { CountdownRender } from "../BookingDetails";
import { useStore } from "effector-react";
import { $countdown } from "../../store/shared/countdown";
import { AppConfig } from "../../config";

const Aside: FC<HTMLProps<HTMLDivElement>> = () => {
  const { t } = useTranslation(AppConfig.translationFileNames.base);
  const countdown = useStore($countdown);

  if (!countdown.enabled) return null;

  return (
    <div className={stl.block}>
      <h2>{t("aside.Title")}</h2>
      <section className={stl.timeWrap}>
        <CountdownRender />
      </section>
      <BookingDetails styleTopOpen />
    </div>
  );
};

export default Aside;
